import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import React, { useMemo } from 'react'
import { Clientes, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { ThemeProvider, createTheme } from '@mui/material'
import { Funcoes } from '../../Utils/Funcoes'
import moment from 'moment'

type Props = {
    cliente: Clientes[],
}

interface RowData {
    id: number,
    id_user_exclusao?: number,
    dh_exclusao?: string,
    motivo_exclusao?: string,
    name_user_delete?: string
    nome: string,
    cnpj_cpf: string,
}

export const GridClienteExcluido = React.memo(({ cliente }: Props) => {

    let user = useSelector(state => selectUser(state))

    const theme = createTheme({
        palette: {
            mode: user.modeDark,
            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569', 
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'

    const colunas = useMemo<MRT_ColumnDef<Clientes>[]>(
        () => [

            {
                accessorKey: 'nome', header: 'Razão Social / Nome', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData
                    return (<span>{rowData.nome ? rowData.nome : <span className={`text-red-400`}>N/D</span>}</span>)
                    
                }
            },

            {
                accessorKey: 'cnpj_cpf', header: 'CPF / CNPJ', size: 150, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData
                    return (<span>{rowData.cnpj_cpf ? Funcoes.FormatDoc(rowData.cnpj_cpf.toString()) : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'name_user_delete', header: 'Usuário de Exclusão', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData
                    return (<span>{rowData.name_user_delete ? rowData.name_user_delete : <span className={`text-red-400`}>N/D</span>}</span>)
                    
                }
            },

            {
                accessorKey: 'motivo_exclusao', header: 'Motivo de Exclusão', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData
                    return (<span>{rowData.motivo_exclusao ? rowData.motivo_exclusao : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'dh_exclusao', header: 'Data de Exclusão', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData
                    return (<span>{rowData.dh_exclusao ? moment(rowData.dh_exclusao).format('DD/MM/YYYY') : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            }, 

        ], []
    )

    const table = useMaterialReactTable({
        columns: colunas,
        data: cliente,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
    })

    return (
        <>
            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table}/>

            </ThemeProvider>
        </>
    )
})